export default __webpack_public_path__ + "static/media/MiniaturaUnconscious.dc7b6e22.jpg";